import React from 'react'
import { InformationalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import { useAppContext } from 'src/containers/AppContext'
import useTracker from 'src/hooks/useTracker'
import { isObjectEmpty } from 'src/utils/object'
import { fetchCheckoutMetaAction } from 'src/redux/checkout'
import { getInvoiceMeta } from 'src/redux/invoice'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import { makeControlledModal } from 'src/decorators/ModalController'

const CheckoutPromoRemovalModal = React.memo(({
  modal,
  type,
  storeOrder,
  ...props
}: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  type: string
  storeOrder: Oms.V4.StoreOrder
}): JSX.Element => {
  const dispatch = useAppDispatch()
  const { formatMoney } = useAppContext()
  const { notifyInitiateCheckout } = useTracker()
  const { t } = React.useContext(TranslationContext)

  if (isObjectEmpty(storeOrder)) {
    return null
  }

  const { id: storeOrderId, total } = storeOrder || {}

  const onConfirm = async () => {
    if (type === 'checkout') {
      await dispatch(fetchCheckoutMetaAction({ storeOrderId }))
      notifyInitiateCheckout()
    } else {
      await dispatch(getInvoiceMeta({ storeOrderId }))
    }
  }

  return (
    <InformationalDialog
      {...modal}
      {...props}
      closeOnBackdropClick={false}
      closeOnEscapeKeyPress={false}
      body={t('Promotion has been removed. Your oder total amount is now _total_', { total: formatMoney(total) })}
      confirmText={t('Close')}
      onConfirm={onConfirm}
    />
  )
})

export default makeControlledModal(CheckoutPromoRemovalModal, 'CheckoutPromoRemovalModal')
